export default "https://cdn-static.gokick.com/assets/6a734ef49f9399dbf744c5b441c6b52a80c19f9a/images/Sleep_Web_Bottle.d29a408775b1bc1a14ec87c9335374d5.png";